import { render, staticRenderFns } from "./manufacturer.vue?vue&type=template&id=17145711&scoped=true&"
import script from "./manufacturer.vue?vue&type=script&lang=js&"
export * from "./manufacturer.vue?vue&type=script&lang=js&"
import style0 from "./manufacturer.vue?vue&type=style&index=0&id=17145711&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17145711",
  null
  
)

export default component.exports